export default {
  required: value => {
    if (value === undefined) return 'Camp obligatoriu!'
    return !!(value || String(value).length) || 'Camp obligatoriu!'
  },
  email: value => {
    /* eslint-disable no-useless-escape */
    const re = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')
    return re.test(value) || 'Nu prea arata ca o adresa de email valida...'
  },
  password: value => {
    if (!value || !value.length) return true
    /* eslint-disable no-useless-escape */
    const re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})')
    return re.test(value) || 'Campul trebuie sa fie de minim 8 caractere lungime si sa contina: litere mici, litere mari, cifre si caractere speciale (!, @, #, $, %, ^, &)!'
  },
  numbersAndLetters: value => {
    const re = new RegExp('^[a-zA-Z0-9_]+$')
    return re.test(value) || 'Campul poate contine doar caractere alfanumerice si underscore (_)!'
  },
  max25: value => {
    return !!(value && value.length <= 25) || 'Campul poate avea o lungime de maxim 25 caractere!'
  },
  max15: value => {
    return !!(value && value.length <= 15) || 'Campul poate avea o lungime de maxim 15 caractere!'
  },
  min3: value => {
    return !!(value && value.length >= 3) || 'Campul poate avea o lungime de minim 3 caractere!'
  },
  min8: value => {
    return !!(value && value.length >= 8) || 'Campul poate avea o lungime de minim 8 caractere!'
  },
  unique: items => function unique (value) {
    if (value === undefined) return true
    return !items.includes(String(value).trim()) || 'Valoarea trebuie sa fie unica in colectia de date'
  },
  accepted: values => value => {
    return !values.includes(String(value)) || `Valorile acceptate sunt: ${values.join(', ')}`
  }
}
